import React from 'react';
import { classList } from 'utils/componentsCommon';

const Hero = ({ children, figure, className, full, centered, overlay, rowlayout, style, ...props }) => {
    const classNames = classList('hero', overlay ? 'overlay' : '', full ? 'full' : '', centered ? 'centered' : '', rowlayout ? 'row' : '', className);

    return (
        <article className={ classNames } style={ figure ? { ...style, backgroundImage: `url("${figure}")` } : style } { ...props }>
            <div>{ children }</div>
        </article>
    );
};

export default Hero;
